export default __webpack_public_path__ + "static/media/BCUBE_ETH.518ed348.svg";